import React, { Component } from "react";

import SEO, { breadcrumbSchema, SITE_URL } from "../common/SEO";
import Header from "../common/Header";
import Footer from "../common/Footer";

import Showcase from "./embedful/Showcase";
import Features from "./embedful/Features";
import SelfSpiel from "../common/SelfSpiel";
import FAQ from "../common/FAQ";
import { EMBEDFUL_FAQ_ITEMS, EMBEDFUL_FEATURES } from "../../constants";
import Preloader from "../../hocs/Preloader";

const EMBEDFUL_JSON_LD = [
  breadcrumbSchema([
    { name: "Home", path: "/" },
    { name: "Embedful", path: "/embedful" },
  ]),
  {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "Embedful",
    url: `${SITE_URL}/embedful`,
    description:
      "Embedful is a SaaS platform for building and embedding secure, customer-facing analytics dashboards, so SaaS teams can launch tenant-aware analytics without building the infrastructure themselves.",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    creator: {
      "@type": "Person",
      name: "Fernan de Dios",
      url: SITE_URL,
    },
    featureList: EMBEDFUL_FEATURES.map((feature) => feature.step),
    sameAs: "https://embedful.io",
  },
];

class Embedful extends Component {
  render() {
    return (
      <div id="page-container" className="full-height">
        <SEO
          title="Embedful: Customer-Facing Analytics Dashboards for SaaS Teams"
          description="Embedful is a SaaS platform for building and embedding customer-facing analytics dashboards, so SaaS teams can launch secure, tenant-aware analytics without building the infrastructure themselves."
          path="/embedful"
          jsonLd={EMBEDFUL_JSON_LD}
        />
        <Header
          id="embedful-banner"
          title="Embedful"
          sub="Launch customer dashboards in minutes."
        />
        <Showcase />
        <Features />
        <FAQ items={EMBEDFUL_FAQ_ITEMS} />
        <SelfSpiel />
        <Footer />
      </div>
    );
  }
}

export default Preloader(Embedful);
